import { Component, EventEmitter, Input, Output } from "@angular/core";
import { HardBtnComponent, HardTranslatePipe } from "@hardcode-kz/ui";
import { IMenuItemModel } from "@models/core/menu";
import { MenuService } from "@dmms/core/menu";
import { NotificationService } from "@dmms/core/notification";
import { ConfirmationDialogService } from "@dmms/shared/ui-kit/dialogs";
import { take } from "rxjs/operators";
import { catchError, of } from "rxjs";
import { NgClass } from "@angular/common";
import { showEnter } from "@dmms/shared/animations/animation";
import { IBaseHttpResponse } from "@models/http/http-options";

@Component({
  selector: "ui-menu-item",
  standalone: true,
  imports: [HardBtnComponent, NgClass, HardTranslatePipe],
  templateUrl: "./ui-menu-item.component.html",
  styleUrl: "./ui-menu-item.component.scss",
  animations: [showEnter],
})
export class UIMenuItemComponent {
  @Input() item: IMenuItemModel;
  @Input() menuId?: string;
  @Input() slug?: string;
  @Input() depth: number = 0;

  @Output() reloadEmit = new EventEmitter<void>();
  @Output() openEmit = new EventEmitter<IMenuItemModel>();

  constructor(
    private menuService: MenuService,
    private notificationService: NotificationService,
    private confirmationService: ConfirmationDialogService,
  ) {}

  open() {
    this.item.show = !this.item.show;
  }

  edit(item: IMenuItemModel) {
    this.openEmit.emit(item);
  }

  remove(item: IMenuItemModel) {
    this.confirmationService
      .removeConfirmationDialog("confirm.delete")
      .afterClosed()
      .subscribe((result) => {
        if (result) {
          this.deleteItem(item);
        }
      });
  }

  deleteItem(item: IMenuItemModel): void {
    item.loading = true;

    this.menuService
      .deleteMenuItem(this.menuId, item.id)
      .pipe(
        take(1),
        catchError(() => of(null)),
      )
      .subscribe((response: IBaseHttpResponse | null) => {
        if (response?.isSuccess) {
          this.notificationService.success("base.recordIsDeleted");
          this.setReload();
        } else {
          item.loading = false;
        }
      });
  }

  setReload(): void {
    this.reloadEmit.emit();
  }
}
